import { render, staticRenderFns } from "./NewStudio.vue?vue&type=template&id=3e5ea826&scoped=true&"
import script from "./NewStudio.vue?vue&type=script&lang=js&"
export * from "./NewStudio.vue?vue&type=script&lang=js&"
import style0 from "./NewStudio.vue?vue&type=style&index=0&id=3e5ea826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ea826",
  null
  
)

export default component.exports